import * as React from "react";
import { forwardRef } from "react";
const SvgSidebarChevronIcon = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 14, height: 8, viewBox: "0 0 14 8", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M13.4 6.29264L11.99 7.70264L6.7 2.41264L1.41 7.70264L0 6.29264L6 0.292637C6.39 -0.0973634 7.02 -0.0973634 7.41 0.292637L13.41 6.29264L13.4 6.29264Z", fill: "currentColor" }));
const ForwardRef = forwardRef(SvgSidebarChevronIcon);
export default ForwardRef;
